/**
 * Protected route component - redirects to login if not authenticated
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@voxapilot/shared';
import { ROUTES } from '../../config/constants';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuthStore();
  const location = useLocation();

  // Show loading while auth state is initializing
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Only redirect if we're sure user is not authenticated
  // (isLoading is false and isAuthenticated is false)
  if (!isLoading && !isAuthenticated) {
    // Redirect to login with return URL
    return <Navigate to={ROUTES.SIGN_IN} state={{ from: location }} replace />;
  }

  // If still loading or authenticated, show children
  return <>{children}</>;
}

